// Static filter options — no mock listing data
export const categories = [
  { id: 'filter-cat-crates', slug: 'crates', label: 'Crates & Kennels' },
  { id: 'filter-cat-bite', slug: 'bite-equipment', label: 'Bite Equipment' },
  { id: 'filter-cat-leads', slug: 'leads-collars', label: 'Leads & Collars' },
  { id: 'filter-cat-ecollars', slug: 'ecollars', label: 'E-Collars' },
  { id: 'filter-cat-training', slug: 'training', label: 'Training Equipment' },
];

export const conditions = [
  { id: 'filter-cond-new', value: 'new', label: 'New' },
  { id: 'filter-cond-like-new', value: 'like-new', label: 'Like New' },
  { id: 'filter-cond-used', value: 'used', label: 'Used' },
  { id: 'filter-cond-well-used', value: 'well-used', label: 'Well Used' },
];

export const regions = [
  { id: 'filter-reg-north-west', value: 'North West', label: 'North West' },
  { id: 'filter-reg-north-east', value: 'North East', label: 'North East' },
  { id: 'filter-reg-yorkshire', value: 'Yorkshire', label: 'Yorkshire' },
  { id: 'filter-reg-east-midlands', value: 'East Midlands', label: 'East Midlands' },
  { id: 'filter-reg-west-midlands', value: 'West Midlands', label: 'West Midlands' },
  { id: 'filter-reg-east', value: 'East', label: 'East of England' },
  { id: 'filter-reg-london', value: 'London', label: 'London' },
  { id: 'filter-reg-south-east', value: 'South East', label: 'South East' },
  { id: 'filter-reg-south-west', value: 'South West', label: 'South West' },
  { id: 'filter-reg-wales', value: 'Wales', label: 'Wales' },
  { id: 'filter-reg-scotland', value: 'Scotland', label: 'Scotland' },
  { id: 'filter-reg-northern-ireland', value: 'Northern Ireland', label: 'Northern Ireland' },
];

export type Listing = {
  id: string;
  title: string;
  price: number;
  category: string;
  category_slug: string;
  condition: 'new' | 'like-new' | 'used' | 'well-used';
  location: string;
  region: string;
  created_at: string;
  description: string;
  images: { src: string; alt: string }[];
  seller_id: string;
  listing_status: string;
  seller?: {
    id: string;
    full_name: string;
    store_name: string | null;
    rating: number;
    review_count: number;
  };
};